import SlidePanel from './SlidePanel'
import {useSlidePanel} from './hooks'


export default SlidePanel
export {useSlidePanel}